$( function() {
	$(document).on('click', 'a[data-modal]', function(e) {
		e.preventDefault();
		var url = $(this).attr('href');
		$.get(url, function(modal) {
			$('.modal-wrapper').remove();
			$(modal).appendTo('body').find('.modal').append( $('<i class="fal fa-times btn-close"></i>') ).on('click', '.btn-close', function(e) {
				console.log($(this));
				$('.modal-wrapper').remove();
			});
		}, 'html');
	});

	$(document).on('submit', '.modal form', function(e) {
		e.preventDefault();
		var $form = $(this);
		var url = $(this).attr('action');
		var method = $(this).attr('method');

		var feedback = $(this).data('feedback') || false;
		var refresh = $(this).data('refresh') || false;
		var autoclose = $(this).data('autoclose') || false;
		var redirect = $(this).data('redirect') || false;

		var _data = $(this).serializeArray();
		var formdata = {};
		for(i = 0; i < _data.length; i++) {
			formdata[ _data[i].name ] = _data[i].value;
		}
		$.ajax({
			url: url,
			method: method,
			data: formdata,
			success: function(res) {
				if(res.error) {
					$errorlist = $form.find('ul.log');
					$errorlist
					.fadeOut()
					.queue( function() {
						$errorlist.empty();
						$.each(res.errors, function(i, msg) {
							$errorlist.append( $('<li class="error">' + msg + '</li>') );
						});
						$errorlist.dequeue();
					})
					.fadeIn();
				}
				else {
					if(refresh) {
						setTimeout( function() {
							location.reload();
						}, refresh);

						/*
						$('.modal').find('.btn-close').off('click').on('click', function(e) {
							location.refresh();
						});
						*/
					}
					if(redirect) {
						setTimeout( function() {
							location.replace(redirect);
						}, refresh);
					}
					if(autoclose) {
						$('.modal-wrapper').remove();
					}
					if(feedback) {
						console.log('feedback?');
						$form.closest('.modal-content').empty().append($(res.feedback));
					}
				}
			}
		});
	});
});